import { FC } from "react";
import { Tab, TabGroup, TabList } from "@headlessui/react";
import { capitalizeAssociatedPress } from "../../../../../helpers/string/capitalize";
import { mergeClassNames } from "../../../../../helpers";
import { StateAction } from "../../../../../helpers/functions/types";
import { SLIDE_OVER_PADDING_STYLES } from "../../../detailedPages/styles";

const TAB_LIST_STYLES =
  "flex space-x-1 rounded-lg bg-stone-200 p-0.5 text-stone-700 dark:bg-stone-900 dark:text-stone-100";

export type SlideOverTabGroupProps = {
  tabs: string[];
  setActiveTabIndex: StateAction<number>;
  defaultIndex?: number;
  tabGroupReference: string;
};

export const SlideOverTabGroup: FC<SlideOverTabGroupProps> = ({
  tabs,
  setActiveTabIndex,
  defaultIndex = 1,
  tabGroupReference,
}) => {
  return (
    <div className={`mt-4 w-full sm:mt-8 ${SLIDE_OVER_PADDING_STYLES}`}>
      <TabGroup
        onChange={(index) => {
          setActiveTabIndex(index);
        }}
        defaultIndex={defaultIndex}
      >
        <TabList className={TAB_LIST_STYLES}>
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              className={({ selected }) =>
                mergeClassNames(
                  "w-full rounded-md py-2 text-sm font-semibold",
                  selected
                    ? "bg-stone-50 shadow dark:bg-stone-700"
                    : "text-stone-500  hover:text-stone-600 dark:hover:text-stone-400",
                )
              }
            >
              {capitalizeAssociatedPress(`${tab} ${tabGroupReference}`)}
            </Tab>
          ))}
        </TabList>
      </TabGroup>
    </div>
  );
};
